<script>
export default {
  name: "ArrowForwardIcon",
  props: {
    arrowColor: {
      type: String,
      default: 'white'
    },

  },
}
</script>

<template>

  <svg v-if="arrowColor === 'white'" fill="none" height="15" viewBox="0 0 28 15" width="28"
       xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1.75806 6.53821C1.20577 6.53821 0.758057 6.98592 0.758057 7.53821C0.758057 8.09049 1.20577 8.53821 1.75806 8.53821V6.53821ZM27.0252 8.24531C27.4157 7.85479 27.4157 7.22163 27.0252 6.8311L20.6613 0.46714C20.2707 0.0766158 19.6376 0.0766158 19.247 0.46714C18.8565 0.857665 18.8565 1.49083 19.247 1.88135L24.9039 7.53821L19.247 13.1951C18.8565 13.5856 18.8565 14.2188 19.247 14.6093C19.6376 14.9998 20.2707 14.9998 20.6613 14.6093L27.0252 8.24531ZM1.75806 8.53821H26.3181V6.53821H1.75806V8.53821Z"
        fill="white"/>
  </svg>
  <svg v-if="arrowColor === 'blue'" fill="none" height="15" viewBox="0 0 28 15" width="28"
       xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1.75806 6.53821C1.20577 6.53821 0.758057 6.98592 0.758057 7.53821C0.758057 8.09049 1.20577 8.53821 1.75806 8.53821V6.53821ZM27.0252 8.24531C27.4157 7.85479 27.4157 7.22163 27.0252 6.8311L20.6613 0.46714C20.2707 0.0766158 19.6376 0.0766158 19.247 0.46714C18.8565 0.857665 18.8565 1.49083 19.247 1.88135L24.9039 7.53821L19.247 13.1951C18.8565 13.5856 18.8565 14.2188 19.247 14.6093C19.6376 14.9998 20.2707 14.9998 20.6613 14.6093L27.0252 8.24531ZM1.75806 8.53821H26.3181V6.53821H1.75806V8.53821Z"
        fill="#563434"/>
  </svg>


</template>

<style lang="scss" scoped>

</style>